import { useState } from 'react';
import logoMark from '../assets/logo-gestion360.png';
import { BRAND } from '../config/brand';
import { acceptConsent } from '../lib/org';
import { LEGAL_VERSION, EMPLOYEE_NOTICE, ADMIN_NOTICE } from '../legal/documents';

// Pantalla de primer ingreso (y de cada nueva versión): aviso de tratamiento de datos + aceptación registrada.
export default function ConsentGate({ isAdmin, onAccepted, onLogout }) {
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  const notice = isAdmin ? [...ADMIN_NOTICE, ...EMPLOYEE_NOTICE.slice(1)] : EMPLOYEE_NOTICE;

  const accept = async () => {
    setBusy(true); setErr('');
    try {
      if (isAdmin) await acceptConsent('terms', LEGAL_VERSION);
      await acceptConsent('privacy', LEGAL_VERSION);
      onAccepted();
    } catch (e) { setErr(e.message || 'No se pudo registrar la aceptación'); }
    setBusy(false);
  };

  return (
    <div style={{ background: 'linear-gradient(135deg,#0f172a,#1e293b)', minHeight: '100vh' }} className="flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-2xl w-full max-w-md p-6">
        <img src={logoMark} alt={BRAND.product} className="w-12 h-12 rounded-2xl mb-3" />
        <h1 className="text-lg font-black text-gray-900">Antes de empezar</h1>
        <p className="text-xs text-gray-400 mb-3">Leé cómo se tratan tus datos en {BRAND.product}.</p>
        <ul className="space-y-2 mb-4">
          {notice.map((t) => <li key={t} className="text-sm text-gray-700 leading-snug flex gap-2"><span className="text-sky-500">•</span><span>{t}</span></li>)}
        </ul>
        <p className="text-xs text-gray-500 mb-3">
          Podés leer el texto completo: {isAdmin && <><a href="/terminos" target="_blank" rel="noreferrer" className="text-sky-600 font-bold">Términos y Condiciones</a> y </>}
          <a href="/privacidad" target="_blank" rel="noreferrer" className="text-sky-600 font-bold">Política de Privacidad</a>.
        </p>
        <label className="flex items-start gap-3 text-sm text-gray-800 mb-4 cursor-pointer">
          <input type="checkbox" checked={ok} onChange={(e) => setOk(e.target.checked)} className="mt-1" />
          <span>{isAdmin ? 'Leí y acepto los Términos y Condiciones y la Política de Privacidad, en nombre de mi organización.' : 'Leí y acepto la Política de Privacidad y el tratamiento de mis datos para el control de asistencia.'}</span>
        </label>
        {err && <p className="text-xs text-red-600 bg-red-50 rounded-xl px-3 py-2 mb-3">{err}</p>}
        <button onClick={accept} disabled={!ok || busy} className="w-full py-3 rounded-2xl text-sm font-bold text-white disabled:opacity-40" style={{ background: 'var(--brand-grad)' }}>
          {busy ? 'Registrando…' : 'Aceptar y continuar'}
        </button>
        <button onClick={onLogout} className="w-full mt-2 text-xs text-gray-400 py-2">No acepto — salir</button>
      </div>
    </div>
  );
}
